import { Navigate } from 'react-router';
import styled from 'styled-components';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { ANY_SPORT_SCOUTING_CENTER } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { Playoffs } from '#src/components/PlayOffs/index.tsx';

const Wrapper = styled.div`
  margin: var(--double-unit) 0;
  @media ${tabletAndAbove} {
    margin: var(--double-unit);
  }
`;

const PlayoffsPage = () => {
  const {
    flags: { nbaPlayoffsConfig },
  } = useFeatureFlags();
  const { generateSportContextPath } = useSportContext();

  if (Object.keys(nbaPlayoffsConfig).length === 0) {
    return (
      <Navigate to={generateSportContextPath(ANY_SPORT_SCOUTING_CENTER)} />
    );
  }
  return (
    <Wrapper>
      <PageHeader text={scoutingCenter.scout} disableBackBrowser />
      <Playoffs />
    </Wrapper>
  );
};

export default PlayoffsPage;
